import { DiceScreen } from "../Games/Dice/components/DiceScreen";

export default function DicePage() {
  return (
    <DiceScreen />
  );
}
